import { render, staticRenderFns } from "./smallLoaderComponent.vue?vue&type=template&id=32307059&scoped=true"
import script from "./smallLoaderComponent.vue?vue&type=script&lang=js"
export * from "./smallLoaderComponent.vue?vue&type=script&lang=js"
import style0 from "./smallLoaderComponent.vue?vue&type=style&index=0&id=32307059&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32307059",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\new-tis\\FR-TISSOT-IFB-Discovery-SFCC\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('32307059')) {
      api.createRecord('32307059', component.options)
    } else {
      api.reload('32307059', component.options)
    }
    module.hot.accept("./smallLoaderComponent.vue?vue&type=template&id=32307059&scoped=true", function () {
      api.rerender('32307059', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "cartridges/int_guidedProductFinder/cartridge/client/default/js/components/smallLoaderComponent.vue"
export default component.exports